import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Button from '../../../../../../../ui/canon/Button';
import SingleColumnTemplate from '../../../../../../../ui/layouts/SingleColumnTemplate';

const SuccessionCfaChoice = ({ cfaType, updateCfaType, updateStep, step, currentUser }) => {
  const intl = useIntl();
  const company = currentUser?.company;
  const companyName = company?.host?.split('.')[0] || '';
  const cashFlowAnalysisWord = intl.locale === 'fr'
    ? (company?.cash_flow_analysis_word_fr || 'Analyse des flux de trésorerie')
    : (company?.cash_flow_analysis_word || 'Cash Flow Analysis');

  return (
    <SingleColumnTemplate variant="wide" columnStyle={{ maxWidth: '96rem' }}>
      <div className="text-center space-y-8">
        <h1 className="text-3xl font-bold text-[var(--succession-text-primary)]">
          <FormattedMessage 
            id="calculators.cfa_wizard.what_type_of_cash_flow" 
            values={{ cash_flow_analysis_word: cashFlowAnalysisWord }}
          />
        </h1>

        {/* Choice Buttons */}
        <div className="flex flex-col md:flex-row gap-8 justify-center items-center">
          {/* Pre-populated Option */}
          <button
            onClick={() => updateCfaType('pre-populated')}
            className={`
              w-80 h-80 p-8 bg-[var(--succession-bg-primary)] rounded-lg shadow-succession-lg border-2 transition-all duration-200 
              hover:shadow-succession-xl hover:scale-105 flex flex-col items-center justify-center text-center
              ${cfaType === 'pre-populated' ? 'ring-2' : 'border-[var(--succession-border)] hover:border-[var(--succession-border-hover)]'}
            `}
            style={cfaType === 'pre-populated' ? { 
              borderColor: 'var(--succession-primary)',
              '--tw-ring-color': 'var(--succession-primary)',
              '--tw-ring-opacity': '0.2'
            } : {}}
          >
            <div className="text-5xl mb-4" style={{ color: 'var(--succession-primary)' }}>
              <i className="fas fa-handshake" />
            </div>
            <h3 className="text-xl font-bold text-[var(--succession-text-primary)] mb-4">
              <FormattedMessage id="calculators.cfa_wizard.use_pre_populate" />
            </h3>
            <p className="text-[var(--succession-text-secondary)] text-sm leading-relaxed">
              <FormattedMessage id="calculators.cfa_wizard.enter_a_purchase_price" />
            </p>
          </button>

          {/* Blank Option */}
          <button
            onClick={() => updateCfaType('blank')}
            className={`
              w-80 h-80 p-8 bg-[var(--succession-bg-primary)] rounded-lg shadow-succession-lg border-2 transition-all duration-200 
              hover:shadow-succession-xl hover:scale-105 flex flex-col items-center justify-center text-center
              ${cfaType === 'blank' ? 'ring-2' : 'border-[var(--succession-border)] hover:border-[var(--succession-border-hover)]'}
            `}
            style={cfaType === 'blank' ? { 
              borderColor: 'var(--succession-primary)',
              '--tw-ring-color': 'var(--succession-primary)',
              '--tw-ring-opacity': '0.2'
            } : {}}
          >
            <div className="text-5xl mb-4" style={{ color: 'var(--succession-primary)' }}>
              <i className="fas fa-money-bill-wave-alt" />
            </div>
            <h3 className="text-xl font-bold text-[var(--succession-text-primary)] mb-4">
              <FormattedMessage id="calculators.cfa_wizard.use_blank" />
            </h3>
            <p className="text-[var(--succession-text-secondary)] text-sm leading-relaxed">
              <FormattedMessage id="calculators.cfa_wizard.guide_you_through_the_process" />
            </p>
          </button>
        </div>

        {/* Continue Button */}
        <Button
          disabled={!cfaType}
          onClick={() => {
            if(cfaType === 'blank') {
              window.location.href = '/succession/calculators/cfa/wizard';
            } else {
              updateStep(step + 1);
            }
          }}
          variant="primary"
          size="lg"
          className="hover:scale-105 transform"
        >
          <FormattedMessage id="calculators.cfa_wizard.continue" />
        </Button>
      </div>
    </SingleColumnTemplate>
  );
};

export default SuccessionCfaChoice; 